import { getJson } from "./apiClient";

export const analyticsService = {
  fetch,
};

function fetch(range = "30d", { mailbox = "", brands = [] } = {}) {
  const params = new URLSearchParams({ range });
  if (mailbox) {
    params.set("mailbox", mailbox);
  }
  if (brands.length) {
    params.set("brands", brands.join(","));
  }
  return getJson(`/api/v1/analytics/?${params}`);
}
